module.exports = __webpack_public_path__ + "static/cannabis-stalks-14d32cfe52e9f0cf06a921bfbc9821d6.jpg";